import CondensedFooter from './CondensedFooter';

export default CondensedFooter;
